export class ProgressBar {
    max: number;
    value: number;
    min: number;
    percentage: string;
}